<template>
    <div class="modal" v-show="modalShown" v-drag="{handle:'#modal-moving'}">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2>kagler割り当て</h2>
        </div>
        <div class="data-area">
          <input type="text" v-model="search">
          <button @click="kaglerSearch">検索</button>
          <div v-for="(user,index) in userList" class="user-list" :key="index">
            <div class="user-name">{{ user.userLastName+ user.userFirstName}}</div>
            <div class="corp-box">
              <div>{{ user.corp.corpName }}</div>
              <div>{{ user.userDepartment }}</div>
            </div>
            <button class="select-btn" @click="kaglerSelect(user.userId)">割り当て</button>
          </div>
        </div>
        <div class="modal-footer">
            <button class="main_btn" @click="close()">閉じる</button>
        </div>
      </div>
    </div>
</template>
<script>
import axios from 'axios'
import {API_URL} from '../../../constants/App'
import * as Api from '../../../utils/Api'

export default {
  name: 'SketchKaglerSelectModal',
  data () {
    return {
      modalShown: false,
      status: '',
      index: '',
      search: '',
      userList: []
    }
  },
  watch: {
  },
  methods: {
    showModal: function (currentStatus, index) {
      this.modalShown = true
      this.status = currentStatus
      this.index = index
    },
    close: function () {
      this.modalShown = false
      this.userList = []
      this.search = ''
    },
    /** kagler検索 */
    kaglerSearch: function () {
      let searchData = this.search
      axios.post(API_URL.LIST + '/kaglerSearch/' + searchData)
        .then(response => {
          this.userList = response.data.data
        }).catch(error => {
          this.modalShown = false
          Api.handleError(error)
        })
        .finally(() => {
          this.onLoad = false
        })
    },
    /** kagler選択 */
    kaglerSelect: function (sketchUploadUserId) {
      axios.post(API_URL.LIST + '/kaglerSelect/' + sketchUploadUserId + '/' + this.status)
        .then(response => {
          this.$emit('kaglerChange', {data: response})
          this.userList = []
          this.search = ''
          this.modalShown = false
        }).catch(error => {
          this.userList = []
          this.search = ''
          this.modalShown = false
          Api.handleError(error)
        })
        .finally(() => {
          this.onLoad = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.modal{
  position: fixed
}

li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
  .error_message{
    padding: 0px;
    width: auto;
  }
}
.data-area {
  padding: 20px;
}
.modal-main{
  max-height: 100%;
}
.row {
  display: flex;
  justify-content: start;
  margin-left: 65px;
  margin-bottom: 30px;
}
.content {
  text-align: left;
}

.user-list{
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
  margin: 10px 0px;
}

.user-name,.corp-box{
  font-size: 15px;
  margin-left: 10px;
}

.select-btn{
  margin-left: 10px;
}

</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/SketchKaglerSelect.vue